import axiosInstance from "../api/axios";

export const getUsersList = async (payload) => {
  const res = await axiosInstance.post("/api/v1/admin/list-users", payload);
  return res.data;
};
